(() => {
  if (window.__peakCartClearInitialized) return;
  window.__peakCartClearInitialized = true;

  const parseKeys = button => {
    try {
      return JSON.parse(button.dataset.cartKeys || '[]');
    } catch (error) {
      return [];
    }
  };

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-clear-cart]');
    if (!button) return;

    const keys = parseKeys(button);
    if (!keys.length) return;

    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'CLEARING…';

    try {
      const updates = {};
      keys.forEach(key => { updates[key] = 0; });

      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ updates })
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to clear cart.');
      }

      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      console.error('[Peak Cart] Clear cart failed:', error);
    }
  });
})();
